import {LogEntry} from "./Models";
import {API_BASE} from "./ApiClient";

import axios, {AxiosResponse} from 'axios';

export default class LogApi {
  private jwtToken: string|null

  constructor(jwtToken: string|null) {
    this.jwtToken = jwtToken
  }

  logs(systemId: string): Promise<LogEntry[]> {
    return axios.get(API_BASE + '/systems/' + systemId + '/logs', {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<LogEntry[]>) => {
        return response.data;
      })
  }

  addLog(systemId: string, log: Partial<LogEntry>): Promise<LogEntry> {
    return axios.post(API_BASE + '/systems/' + systemId + '/logs', log, {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<LogEntry>) => {
        return response.data;
      })
  }

  updateLog(logId: string, log: Partial<LogEntry>): Promise<LogEntry> {
    return axios.put(API_BASE + '/logs/' + logId, {
      ...log
    }, {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<LogEntry>) => {
        return response.data;
      })
  }

  removeLog(id: string): Promise<void> {
    return axios.delete(API_BASE + '/logs/' + id, {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<void>) => {
        return
      })
  }
};